import axios from 'axios'
import FileData from '@/domain/FileData'

/**
 * 報告書テンプレートサービス
 */
export default class ReportTemplateService {
    /** インスタンス */
    private static _instance: ReportTemplateService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new ReportTemplateService();
        }
        return this._instance;
    }

    /**
     * 報告書ダウンロード
     */
    public async download(code: string, requestNo: string): Promise<FileData> {
        return await axios.get(`/api/report_template/download/${code}/${requestNo}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                throw error
            })
    }

    /**
     * 受信データの変換
     * @param data
     */
    // eslint-disable-next-line
    private convert(data: any): FileData {
        const fileData = data as FileData

        return new FileData({ ...fileData })
    }
}
